export function resolveTokenLogoUrl(symbol: string): string {
    return `https://raw.githubusercontent.com/TrainProtocol/icons/main/tokens/${symbol.toLowerCase()}.png`;
}
